/** Parses a dot-separated version string ("1.4.2") into numeric parts, or null if malformed. */
const parseVersion = (value: string): number[] | null => {
  const parts = value.trim().split(".").map((part) => Number.parseInt(part, 10));
  if (parts.length === 0 || parts.some((part) => Number.isNaN(part) || part < 0)) {
    return null;
  }
  return parts;
};

/**
 * True only when `installed` is strictly below `minimum`. Fails open (returns false —
 * never block) when `minimum` is null/empty or either version string doesn't parse
 * cleanly, since this backs a force-update gate where availability outweighs enforcement.
 */
export const isVersionBelow = (installed: string, minimum: string | null | undefined): boolean => {
  if (!minimum || !minimum.trim()) return false;

  const installedParts = parseVersion(installed);
  const minimumParts = parseVersion(minimum);
  if (!installedParts || !minimumParts) return false;

  const length = Math.max(installedParts.length, minimumParts.length);
  for (let i = 0; i < length; i++) {
    const a = installedParts[i] ?? 0;
    const b = minimumParts[i] ?? 0;
    if (a < b) return true;
    if (a > b) return false;
  }
  return false;
};
